"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationPermissionWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var useFirebaseMessaging_1 = require("../../hooks/useFirebaseMessaging");
var description = 'NotificationPermissionWatcher';
var NotificationPermissionWatcher = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var setToken = (0, useFirebaseMessaging_1.useFirebaseMessaging)({
        parentDescription: description,
    }).setToken;
    (0, react_1.useEffect)(function () {
        setToken();
    }, [setToken]);
    (0, react_1.useEffect)(function () {
        var removeEventListener;
        var watchPermissionStatus = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var permissionStatus_1, changeListener_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(typeof navigator !== 'undefined' && navigator.permissions)) return [3 /*break*/, 2];
                        return [4 /*yield*/, navigator.permissions.query({
                                name: 'notifications',
                            })];
                    case 1:
                        permissionStatus_1 = _a.sent();
                        if (permissionStatus_1) {
                            changeListener_1 = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                                return tslib_1.__generator(this, function (_a) {
                                    if (permissionStatus_1.state === 'granted' ||
                                        permissionStatus_1.state === 'prompt') {
                                        dispatch({
                                            type: 'SET_COOKIE_STORAGE',
                                            description: description,
                                            values: {
                                                dontAskToEnableNotificationMs: 0,
                                            },
                                        });
                                    }
                                    if (permissionStatus_1.state === 'granted') {
                                        // Do not get getFirebaseMessagingToken because there might be a conflict causing two tokens
                                        dispatch({
                                            type: 'SET_WINDOW_META',
                                            values: {
                                                notificationPermission: permissionStatus_1.state,
                                            },
                                            description: description,
                                        });
                                    }
                                    else {
                                        dispatch({
                                            type: 'SET_WINDOW_META',
                                            values: {
                                                firebaseMessagingToken: null,
                                                notificationPermission: permissionStatus_1.state,
                                            },
                                            description: description,
                                        });
                                    }
                                    return [2 /*return*/];
                                });
                            }); };
                            permissionStatus_1.addEventListener('change', changeListener_1);
                            removeEventListener = function () {
                                permissionStatus_1.removeEventListener('change', changeListener_1);
                            };
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        watchPermissionStatus();
        return function () {
            removeEventListener === null || removeEventListener === void 0 ? void 0 : removeEventListener();
        };
    }, [dispatch]);
    return null;
};
exports.NotificationPermissionWatcher = NotificationPermissionWatcher;
